import BaseLibraryIconSvg from '../../../../../components/Icon/BaseLibraryIconSvg';
import { IconSvgProps } from '../../../../../components/Icon/Icon';

const CheckFilled = (props: IconSvgProps) => {
  const { backgroundColor, ...baseProps } = props;
  return (
    <BaseLibraryIconSvg {...baseProps}>
      <path
        d='M11.9957 22C17.4667 22 22 17.4734 22 12C22 6.52659 17.458 2 11.9869 2C6.5207 2 2 6.52659 2 12C2 17.4734 6.52941 22 11.9957 22ZM10.9047 16.8095C10.6035 16.8095 10.3663 16.6932 10.1339 16.3871L8.84295 14.8185L7.55203 13.2499C7.41449 13.0823 7.34182 12.8846 7.34182 12.6869C7.34182 12.2867 7.64215 11.9679 8.04303 11.9679C8.29201 11.9679 8.48963 12.0494 8.69682 12.3342L10.866 15.0555L15.2552 8.06776C15.4141 7.80037 15.6417 7.66277 15.8742 7.66277C16.2616 7.66277 16.6102 7.92447 16.6102 8.33427C16.6102 8.52415 16.5066 8.73054 16.3943 8.89909L11.6321 16.3871C11.4432 16.6719 11.1972 16.8095 10.9047 16.8095Z'
        fill='currentColor'
      />
      <path
        d='M10.1358 16.3874C10.3682 16.6935 10.6055 16.8098 10.9067 16.8098C11.1992 16.8098 11.4451 16.6722 11.634 16.3874L16.3963 8.89941C16.5086 8.73086 16.6122 8.52446 16.6122 8.33458C16.6122 7.92479 16.2635 7.66309 15.8761 7.66309C15.6437 7.66309 15.416 7.80069 15.2572 8.06807L10.8679 15.0558L8.69875 12.3345C8.49156 12.0497 8.29393 11.9683 8.04496 11.9683C7.64408 11.9683 7.34375 12.287 7.34375 12.6872C7.34375 12.8849 7.41642 13.0826 7.55396 13.2503L8.84488 14.8188L10.1358 16.3874Z'
        fill={backgroundColor || 'white'}
      />
    </BaseLibraryIconSvg>
  );
};

export default CheckFilled;
